import { State } from '../../model';
import { VariableState } from '../../communication';
import { ConditionalEnableElement } from './conditional-enable-element';
import { forEach } from 'lodash';
import { VariableUtil } from '../../utils/variable-util';
export class ReadableElement extends ConditionalEnableElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore, localization) {
        super(element, permissionChecker, variableCommunicator, variableStore, localization);
    }
    init(variableName) {
        if (variableName) {
            let hasVariable = false;
            forEach(this.elementStates, elementState => {
                if (elementState.variableName === variableName) {
                    hasVariable = true;
                }
            });
            if (!hasVariable) {
                this.elementStates.push(new VariableState(variableName, undefined));
            }
        }
        this.initState();
    }
    get readVariableName() {
        if (!this.model) {
            throw new Error('Model cannot be null');
        }
        if (null == this.model.version || this.model.version < 2) {
            return this.model.variableName;
        }
        else {
            const variable = this.model.readVariable;
            if (!variable) {
                return undefined;
            }
            return VariableUtil.getConvertedVariableName(this.variableStore, variable);
        }
    }
    reportStateChanged(variableState) {
        forEach(this.elementStates, elementState => {
            if (elementState.variableName === variableState.variableName) {
                elementState.state = variableState.state;
                this.changeStates();
            }
        });
    }
    reportValueChanged(value) {
        forEach(this.elementStates, elementState => {
            if (elementState.variableName === value.variableName) {
                elementState.state = value.state;
                this.changeStates();
            }
        });
        if (this.state === State.Normal || this.state === State.Disable) {
            this.updateVariableValue(value.value);
        }
    }
}
